import { useEffect, useState } from "react";
import "./RotatingBackground.css";

const backgroundImages = [
    "/images/HomePage/homepage1.jpg",
    "/images/HomePage/homepage2.jpg",
    "/images/HomePage/homepage3.jpg",
    "/images/HomePage/homepage4.jpg",
];

const RotatingBackground = ({ children, interval = 60000 }) => {
    const [index, setIndex] = useState(0);
    const [animateKey, setAnimateKey] = useState(0); // Forces re-animation

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex(prev => (prev + 1) % backgroundImages.length);
            setAnimateKey(prev => prev + 1);
        }, interval);

        return () => clearInterval(timer);
    }, [interval]);

    return (
        <div className="rotating-bg-container">
            <div
                key={animateKey} // ensures the animation restarts
                className="zoom-out-bg"
                style={{ backgroundImage: `url(${backgroundImages[index]})` }}
            />
            <div className="overlay">
                {children}
            </div>
        </div>
    );
};

export default RotatingBackground;
